import React from "react";
import { C } from "../theme";

export default function CondRow({ label, value, status }) {
  const sc = status === "good" ? C.accent : status === "warn" ? C.gold : C.muted;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "7px 0",
        borderBottom: `1px solid ${C.border}`,
      }}
    >
      <span style={{ fontSize: 11, color: C.muted }}>{label}</span>
      <span style={{ fontSize: 11, fontWeight: 700, color: sc }}>{value}</span>
    </div>
  );
}
